module.exports = __webpack_public_path__ + "img/products_big_can_tropical.c2c08878.png";